import { Injectable } from '@angular/core';
import { WebApiService } from '../../../../shared/services/web-api.service';
import { SettingsService } from 'src/app/views/settings/settings.service';

@Injectable({
  providedIn: 'root'
})
export class sessionService {

  private readonly GUEST_SESSION_KEY = 'guestSessionId';

  constructor(
    private webApiService: WebApiService,
    private settingService: SettingsService,

    ) { } 


    // 2026-10-23: the guest recent-search id is issued by the API (a random UUID, returned by
    // POST /settings/CreateUserSearchHistory on a guest's first search) instead of being made here with
    // Math.random. An id stored earlier keeps working; the API moves its rows to a new UUID on the next search.
    getSessionId(): string {
          return this.getStoredGuestSessionId();
      }

    /** The guest history id kept in localStorage, or '' when the API has not issued one yet. */
    getStoredGuestSessionId(): string {
        try { return localStorage.getItem(this.GUEST_SESSION_KEY) || ''; } catch { return ''; }
    }

    /** Keeps the id the API issued (or migrated to). */
    storeGuestSessionId(id: string | null | undefined): void {
        if (!id) return;
        try { localStorage.setItem(this.GUEST_SESSION_KEY, id); } catch { /* storage unavailable: history stays per page */ }
    }

    /** Kept for existing callers: no longer invents an id, returns the stored one ('' if none yet). */
    generateGuestSessionId(): string {
        return this.getStoredGuestSessionId();
    }

    removeSessionId() {
        localStorage.removeItem('guestSessionId');
        console.log('Session ID removed from localStorage.');
      }
      
    
      
    


}